module.exports = __webpack_public_path__ + "media/NeueHaasUnicaW1G-Medium.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/NeueHaasUnicaW1G/NeueHaasUnicaW1G-Medium.eot
// module id = 580
// module chunks = 57